import ApiService from "../api";

export default class ClienteService extends ApiService {

    constructor() {
        super('/api/clientes')
    }

    buscarPorCodigo(codigo) {
        return this.get(`/buscar-por-codigo/${codigo}`)
    }
}
